module.exports = __webpack_public_path__ + "img/vertical_1_1_8004.e677e785.png";